import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducer, userFeatureKey } from './user-reducer';
import { payrateFeatureKey, payRateReducer } from './pay-rate-reducer';
import { PayRateEffects } from './effects/pay-rate.effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(userFeatureKey, reducer),
        StoreModule.forFeature(payrateFeatureKey, payRateReducer),
        EffectsModule.forFeature([PayRateEffects])
    ]
})
export class PerdiemStoreModule {}
